import { PROJECT_NAME } from "../config";

const assetModules = require.context("../assets/images", true, /\.(png|jpe?g|svg|mp4)$/);

// Priority order: project-specific → common-icons → root of assets/images
// Add new fallback folders here — components never need to change
const FALLBACK_FOLDERS = [
  ...(PROJECT_NAME ? [PROJECT_NAME] : []),
  "common-icons",
  null, // null = root of assets/images
];

export const getAsset = (baseName) => {
  const extensions = [".svg", ".png", ".jpg", ".jpeg", ".mp4"];

  for (const ext of extensions) {
    for (const folder of FALLBACK_FOLDERS) {
      const path = folder ? `./${folder}/${baseName}${ext}` : `./${baseName}${ext}`;
      try {
        return assetModules(path);
      } catch {
        // not found in this path, try next
      }
    }
  }

  console.warn(`Asset not found: ${baseName} (version: ${PROJECT_NAME})`);
  return null;
};
